<template>
  <div>
    <div class="modal fade" :id="`modalSuggestNCCN`">
      <div class="modal-dialog modal-lg shadow" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" @click="setSize">NCCN</h5>
          </div>
          <div v-loading="loading" class="modal-body txt-grey-900">
            <!--  -->
            <div class="content flex flex-row justify-center gap-4">
              <!-- Back Btn -->
              <div v-if="guidelineUrl" style="width: 100%;">
                <el-button class="mb-3" type="primary" @click="guidelineUrl = ''">
                  Trở về
                </el-button>
                <iframe id="nccn-wiew-page" :src="guidelineUrl" name="nccn"></iframe>
              </div>
              <!-- List Guideline -->
              <div v-else class="guidelines"
                style="box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px; border-radius: 10px; padding: 20px; width: 100%;">
                <h3 v-if="isEmpty">Bạn có thể tham khảo nội dung dưới đây.</h3>
                <!-- Guideline item -->
                <div class="guideline-item" v-for="(item, index) in guidelines" :key="index"
                  @click="selectGuideline(item)">
                  <span>{{ item.title }}</span>
                </div>
                <AppPagination :paginationProps="{
                  currentPage: paging.page_num,
                  totalItems: paging.total,
                  pageSize: paging.page_size,
                }" @onChangePagination="(data) => handleChangePagination(data)" />
              </div>
              <div class="sidebar" style="width: 250px;">
                <h2>TÓM TẮT BỆNH ÁN</h2>
                <div class="box">
                  <p>Tóm tắt bệnh án</p>
                  <div class="create-date">Ngày tạo: 12:30 | 11/12/2024</div>
                </div>
              </div>
            </div>
            <!--  -->
            <div class="mt-4 text-sm font-medium flex justify-end">
              <button @click="handleCloseModal"
                class="flex items-center justify-center border-0 focus:outline-none bg-blue-50 text-primary rounded-md h-9 px-3 py-2">
                <div>Hủy</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AppPagination } from '@/components/Common'

const DEFAULT_FORM = {
  created_by: '',
  created_at: window.moment().format('YYYY-MM-DD'),
  is_public: 0,
  emr_template_id: null,
  doc_name: ''
}

export default {
  name: 'ModalSuggestNCCN',
  props: {
    docContent: Object,
    docType: String
  },
  components: {
    AppPagination
  },
  data () {
    return {
      form: {
        ...DEFAULT_FORM
      },
      loading: false,
      emrTemplateList: [],
      searchFilter: {},
      guidelines: [],
      guidelineUrl: '',
      paging: {
        page_num: 1,
        page_size: 10000,
        total: 0
      },
      isEmpty: false
    }
  },
  computed: {
    isAdmin () {
      const isTrue = this.$globalClinic && this.$user && this.$user.doctor && this.$globalClinic.doctor_id === this.$user.doctor.id
      if (!isTrue) this.form.is_public = 0
      return isTrue
    }
  },
  mounted () {
    if (this.$user) {
      this.form.created_by = this.$user.name
    }
  },
  methods: {
    async getGuidelines () {
      this.loading = true
      const response = await this.$rf
        .getRequest('NCCNRequest')
        .getLinkGuidelines(this.searchFilter, this.paging)

      if (response.code === 200) {
        this.guidelines = response.data.data
        // Paging
        this.paging.page_num = response.data.page_num
        this.paging.page_size = response.data.page_size
        this.paging.total = response.data.total

        this.loading = false

        if (this.guidelines == null) {
          this.isEmpty = true
          //
          this.searchFilter = {}
          this.paging.page_num = 1
          this.paging.page_size = 5
          await this.getGuidelines()
        }
      }
    },
    async handleChangePagination (data) {
      this.paging.page_num = data.currentPage
      await this.getGuidelines()
    },
    selectGuideline (item) {
      this.guidelineUrl = item.url
    },
    showModalSuggestNCCN (show, searchFilter) {
      if (show) {
        // assign data filter
        this.searchFilter = searchFilter

        // Mutations
        if (searchFilter.mutations && searchFilter.mutations.length > 0) {
          this.searchFilter.mutations = searchFilter.mutations.reduce((arr, item) => [...arr, item.name, item.value], [])
        }

        if (this.searchFilter.stage == '' && this.searchFilter.t_code == '' && this.searchFilter.n_code == '' && this.searchFilter.m_code == '') this.paging.page_size = 5
        this.getGuidelines()
        window.addEventListener('DOMContentLoaded', function (e) { })
      }

      window.$(`#modalSuggestNCCN`).modal(show ? 'show' : 'hide')
    },
    setSize () {
      var iFrame = document.getElementById('nccn-wiew-page')
      iFrame.width = iFrame.contentWindow.document.body.scrollWidth
      iFrame.height = iFrame.contentWindow.document.body.scrollHeight
      console.log(iFrame.width, iFrame.contentWindow.document.body.scrollWidth)
      console.log(iFrame.height, iFrame.contentWindow.document.body.scrollHeight)
    },
    handleCloseModal () {
      this.showModalSuggestNCCN(false)
      this.form = { ...DEFAULT_FORM, created_by: this.$user.name }
    }
  }
}
</script>
<style lang="scss" scoped>
#nccn-wiew-page {
  width: 100%;
  height: 70vh;
}

.modal-body {
  max-height: 90vh !important;
}

.guideline-item {
  padding: 10px 8px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.2s ease-in;

  &:hover {
    background-color: #eeeeee;
  }
}
</style>
